import React from "react";
import { createRoot } from "react-dom/client";
import "primereact/resources/primereact.min.css";
import "primeflex/primeflex.min.css";
import "react-toastify/dist/ReactToastify.css";
import "@idwal/idwal-react-components/css/idwal-theme.css";
import "primeicons/primeicons.css";
import "./index.css";
import common_en from "@idwal/idwal-react-components/translations/en/common.json";
import app_locale_en from "./translations/en/locale.json";
import { AwsConfigAuth } from "./cognito/authConfig";
import { Amplify } from "aws-amplify";
import i18next from "i18next";
import { I18nextProvider } from "react-i18next";
import { Authenticator } from "@aws-amplify/ui-react";
import { Provider } from "react-redux";
import { LDProvider } from "launchdarkly-react-client-sdk";

import { RouterProvider } from "react-router-dom";

import { CookiesProvider } from "react-cookie";
import { createRouter } from "./config/router";
import { store } from "./redux/store";

Amplify.configure(AwsConfigAuth);
i18next.init({
    interpolation: { escapeValue: false },
    lng: "en",
    resources: {
        en: {
            common: common_en,
            locale: app_locale_en
        }
    }
});

const clientSideId = process.env.REACT_APP_LD_CLIENT_SIDE_ID ?? '';


const rootElement = document.getElementById("root");
if (rootElement) {
    const root = createRoot(rootElement);
    root.render(
        <React.StrictMode>
            <CookiesProvider>
                <Provider store={store}>
                    <LDProvider clientSideID={clientSideId}>
                        <I18nextProvider i18n={i18next}>
                            <Authenticator.Provider>
                                <RouterProvider router={createRouter()} />
                            </Authenticator.Provider>
                        </I18nextProvider>
                    </LDProvider>
                </Provider>
            </CookiesProvider>
        </React.StrictMode>
    );
} else {
    console.error("Failed to find the root element");
}
